import { useState, useEffect, useRef } from 'react';
import { getFolderList, createFolder, renameFolder, deleteFolder as deleteFolderApi, moveTaskToFolder, getTasksByFolder, Folder as FolderType } from '../services/folder';
import { Task } from '../services/task';

export interface FolderWithExpanded extends FolderType {
    expanded: boolean;
    tasks?: Task[];
    tasksLoading?: boolean;
}

export function useFolders(language: string) {
    const [folders, setFolders] = useState<FolderWithExpanded[]>([]);
    const [foldersLoading, setFoldersLoading] = useState(true);
    const [editingFolderId, setEditingFolderId] = useState<string | null>(null);
    const [editingFolderName, setEditingFolderName] = useState('');
    const [draggingTaskId, setDraggingTaskId] = useState<string | null>(null);
    const [dragOverFolderId, setDragOverFolderId] = useState<string | null>(null);
    const folderInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const fetchFolders = async () => {
            setFoldersLoading(true);
            try {
                const response = await getFolderList();
                const foldersWithExpanded = (response || []).map(f => ({
                    ...f,
                    expanded: false
                }));
                setFolders(foldersWithExpanded);
            } catch (e: any) {
                console.error('Failed to fetch folders:', e);
                setFolders([]);
            } finally {
                setFoldersLoading(false);
            }
        };
        fetchFolders();
    }, []);

    const displayFolderName = (name: string) => {
        if (language === 'en') {
            const match = name.match(/^新建文件夹(\d*)$/);
            if (match) return `New Folder${match[1]}`;
        }
        return name;
    };

    const handleDeleteFolder = async (folderId: string) => {
        await deleteFolderApi(folderId);
        setFolders(prev => prev.filter(f => f.folderId !== folderId));
    };

    return {
        folders, setFolders, foldersLoading, setFoldersLoading,
        editingFolderId, setEditingFolderId,
        editingFolderName, setEditingFolderName,
        draggingTaskId, setDraggingTaskId,
        dragOverFolderId, setDragOverFolderId,
        folderInputRef,
        displayFolderName,
        handleDeleteFolder
    };
}
